<template>
  <div class="r_box">
    <div class="r_cbox">
      <span>学生姓名</span>
      <el-select class="r_select" v-model="uname" placeholder="全部">
        <!-- <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option> -->
      </el-select>
    </div>
    <div class="r_cbox">
      <span>选择阶段</span>
      <el-select  class="r_select" v-model="chap" multiple collapse-tags placeholder="请选择阶段">
        <!-- <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option> -->
      </el-select>
    </div>
    <div class="r_cbox">
      <span>任务内容</span>
      <el-select  class="r_select" v-model="task" multiple collapse-tags placeholder="全部">
        <!-- <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option> -->
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uname: [],
      chap: [],
      task: [],
    };
  },
};
</script>

<style scoped>
.r_box {
}
.r_cbox {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.r_cbox span {
    margin-right: 20px;
}

.r_box .r_select{
    width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/components/report.vue